import { render, staticRenderFns } from "./DatabaseManagementModal.vue?vue&type=template&id=1e531230"
import script from "./DatabaseManagementModal.vue?vue&type=script&lang=js"
export * from "./DatabaseManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports